const SPICES = [
  { name: "Haldi", hindi: "हल्दी" },
  { name: "Lāl Mirch", hindi: "लाल मिर्च" },
  { name: "Jeera", hindi: "जीरा" },
  { name: "Dhaniya", hindi: "धनिया" },
  { name: "Garam Masala", hindi: "गरम मसाला" },
  { name: "Elaichi", hindi: "इलायची" },
  { name: "Laung", hindi: "लौंग" },
  { name: "Hing", hindi: "हींग" },
  { name: "Dalchini", hindi: "दालचीनी" },
  { name: "Kali Mirch", hindi: "काली मिर्च" },
];

export const SpiceMarquee = () => {
  const loop = [...SPICES, ...SPICES];
  return (
    <div
      data-testid="spice-marquee"
      className="relative overflow-hidden bg-mo-terracotta text-mo-cream py-6 border-y border-[#F9F6F0]/10"
    >
      <div className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "5px 5px",
        }}
      />
      <div className="relative flex gap-12 whitespace-nowrap marquee-track">
        {loop.map((s, i) => (
          <span key={i} className="flex items-center gap-6 shrink-0">
            <span className="font-serif-display italic text-3xl sm:text-4xl">
              {s.name}
            </span>
            <span className="font-serif-display text-xl sm:text-2xl text-[#D99026]">
              {s.hindi}
            </span>
            <span className="text-[#F9F6F0]/60 text-2xl">✦</span>
          </span>
        ))}
      </div>

      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .marquee-track {
          width: max-content;
          animation: marquee 38s linear infinite;
        }
        .marquee-track:hover { animation-play-state: paused; }
      `}</style>
    </div>
  );
};
